<template>

<div>
    <template v-if="$route.query.package">
        <SubElement/>
    </template>
    <template v-if="!$route.query.package">
        <TvApiSubs/>
    </template>
</div>



</template>

<script>
    import TvApiSubs from '@/components/TvApiSubs.vue'
    import SubElement from '@/components/SubElement.vue'
    import {mapGetters, mapMutations} from 'vuex'
    export default {
        name: 'List',
        async mounted() {

            this.$store.dispatch('fetchItems')
        },

        components: {
            TvApiSubs,
            SubElement
        },
        computed: {
            ...mapGetters([
                'detailInfo',
                'getAllPosts'
            ])
        },
        methods: {}
    }
</script>

<style scoped>

</style>